<template>
  <div
    class="w-10 h-10 grid justify-center items-center rounded-full"
    :class="{
      'bg-gray-500 text-white': status === 'missed',
      'text-primary-500 border-2 border-primary-500': status === 'checked',
      'text-gray-400 border-2 border-gray-400': status === 'ongoing',
      }"
  >
    <div class="font-medium">
      <span v-if="status !== 'checked'">{{ day }}</span>
      <span v-else>
        <icon name="Check" :settings="{ circle: false }" size="1.5em" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityWeekDay",
  data() {
    return {};
  },
  props: {
    day: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: null
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>
